import React, { useEffect } from "react";
import { decodeToken } from "react-jwt";
import { useAppDispatch, useAppSelector } from "../store/reduxHooks";
import { setUser } from "../store/mosaic/userSlice";
import { getCookie } from "../utils/cookie";

type TProps = {
  children: React.ReactElement;
};

interface IJwt {
  sub: any[];
}

const AuthContainer: React.FC<TProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const cookie = getCookie();
    if (cookie) {
      const jwtData = decodeToken<IJwt>(cookie);
      dispatch(setUser(jwtData?.sub));
    }
  }, [dispatch]);

  return children;
};

export default AuthContainer;
